import SidebarToggle from 'components/Widget/Button/SidebarToggle';
import * as S from './styles';

interface TabBarProps {
	labels: string[];
	activeLabel: string;
	onChange: (label: string) => void;
}

const TabBar = ({ labels, activeLabel, onChange }: TabBarProps) => {
	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base>
			<S.SidebarToggleWrapper>
				<SidebarToggle />
			</S.SidebarToggleWrapper>
			<S.Divider />
			<S.Tabs>
				{labels.map((label) => (
					<S.Tab key={label} active={label === activeLabel} onClick={() => onChange(label)}>
						{label}
					</S.Tab>
				))}
			</S.Tabs>
		</S.Base>
	);
};

export default TabBar;
